import { DateTime } from "luxon"

//Styles
import myStyles from "../../../styles/housing/HousingAllocations.module.css"

//PrimeReact
import { Tooltip } from "primereact/tooltip"
import { Badge } from "primereact/badge"

export default function OpenBed({
  bed,
  setSelectedBed,
  setShowForm,
  onEditStay,
  bedOccupants,
  participants,
}) {
  const nowUtc = DateTime.now().toUTC()
  const occupant = bedOccupants?.filter((x) => x.bed.id === bed.id)
  const currentOccupant = !!occupant
    ? occupant.filter(
        (x) =>
          nowUtc > DateTime.fromISO(x.start, { zone: "utc" }) &&
          nowUtc < DateTime.fromISO(x.end, { zone: "utc" })
      )
    : undefined

  let currentOccupantName = " a participant"

  if (!!currentOccupant && currentOccupant.length > 0 && !!participants) {
    const participant = participants.find(
      (participant) =>
        participant.participant_id === currentOccupant[0].participantId
    )
    currentOccupantName = participant?.name2
  }

  const FutureOccupationBadge = ({ nowUtc }) => {
    if (!!bedOccupants) {
      const upcomingOccupants = occupant.filter(
        (x) => nowUtc < DateTime.fromISO(x.start, { zone: "utc" })
      )
      let tooltip = `This bed has no bookings`

      if (upcomingOccupants.length > 0) {
        const bookingText =
          upcomingOccupants.length > 1 ? "bookings" : "booking"
        tooltip = `This bed has ${upcomingOccupants.length} upcoming ${bookingText}`

        if (!!currentOccupant && currentOccupant.length > 0) {
          tooltip = `This bed is currently occupied and has ${upcomingOccupants.length} upcoming ${bookingText}`
        }
      } else if (!!currentOccupant && currentOccupant.length > 0) {
        tooltip = `This bed is currently occupied and has 0 upcoming bookings`
      }
      return (
        <>
          <Tooltip target=".openBedFutureOccupationBadge_tt" />
          <div
            className={`${myStyles.openBedFutureBookings} openBedFutureOccupationBadge_tt`}
            data-pr-tooltip={tooltip}
          >
            <span className={`material-icons`}>{"person"}</span>:{" "}
            {!!occupant ? occupant.length : 0}
          </div>
        </>
      )
    } else {
      return <></>
    }
  }

  return (
    <div className={myStyles.roomGridContainer}>
      <div className={myStyles.roomGridItemName}>
        <b style={{ color: "#666666", padding: "2px" }}>{bed.name}</b>
      </div>
      <div className={myStyles.roomGridItemBookings}>
        <FutureOccupationBadge nowUtc={nowUtc} />
      </div>
      <div className={myStyles.roomGridItemButton}>
        <Tooltip target=".openBed_tt" />
        <button
          type="submit"
          className={`btn-sm ${myStyles.bedAssignButton} p-overlay-badge openBed_tt`}
          data-pr-tooltip={
            !!currentOccupant && currentOccupant.length > 0
              ? `This bed is currently occupied by ${currentOccupantName}`
              : "This bed is not currently occupied"
          }
          onClick={() => {
            setSelectedBed(bed)
            onEditStay(undefined)
            setShowForm(true)
          }}
        >
          Assign
          {!!currentOccupant ? (
            <Badge
              severity={currentOccupant.length > 0 ? "warning" : "success"}
            />
          ) : null}
        </button>
      </div>
    </div>
  )
}
